import React, { ReactNode, FormEvent } from 'react';
import styles from './EditProfileModal.module.css';

interface EditProfileModalProps {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
  isLoading?: boolean;
  error?: string;
  children: ReactNode;
}

function EditProfileModal({ 
  title,
  isOpen,
  onClose,
  onSubmit,
  isLoading = false,
  error,
  children 
}: EditProfileModalProps): JSX.Element | null {
  if (!isOpen) return null;

  const content = (
    <>
      {children}
      {error && <div className={styles.errorMessage}>{error}</div>}
    </>
  );

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h2>{title}</h2>
        {onSubmit ? (
          <form onSubmit={(e) => {
            // Ensure we prevent default form submission
            e.preventDefault();
            onSubmit(e);
          }}>
            {content}
            <div className={styles.modalButtons}>
              <button
                type="button"
                onClick={onClose}
                className={styles.cancelButton}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className={styles.saveButton}
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className={styles.spinner} />
                ) : (
                  'Save'
                )}
              </button>
            </div>
          </form>
        ) : (
          <div>
            {content}
            <div className={styles.modalButtons}>
              <button
                type="button"
                onClick={onClose}
                className={styles.cancelButton}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EditProfileModal; 